import types from "./types";

const INITIAL_STATE = {
  isFetchingAwv: false,
  isHmoMember: false,
  selectedProviderKeyId: "",
  isFetchingHmoMetrics: false,
  isUpdatingHmoMetrics: false,
  isRefreshingMemberAwvStatus: false,
  isDownloadingMemberPafs: false,
  isDownloadingMemberStatusExcel: false,
  isDownloadingMemberStatusPdf: false,
};


const hmoReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case types.GET_HMO_AWV_REQUEST:
      return {
        ...state,
        isFetchingAwv: true,
        selectedProviderKeyId: action.payload,
      };

    case types.GET_HMO_AWV_SUCCESS:
      return {
        ...state,
        isFetchingAwv: false,
        isAcoMember: action.payload.length !== 0,
      };

    case types.GET_HMO_AWV_FAILURE:
      return {
        ...state,
        isFetchingAwv: false,
      };

    case types.GET_HMO_METRICS_REQUEST:
      return {
        ...state,
        isFetchingHmoMetrics: true,
        selectedProviderKeyId: action.payload,
      };

    case types.GET_HMO_METRICS_SUCCESS:
      return {
        ...state,
        isFetchingHmoMetrics: false,
        isAcoMember: action.payload.length !== 0,
      };

    case types.GET_HMO_METRICS_FAILURE:
      return {
        ...state,
        isFetchingHmoMetrics: false,
      };


    case types.GET_MEMBER_MPI_REQUEST:
      return {
        ...state,
        isFetchingMemberMpi: true,
      };

    case types.GET_MEMBER_MPI_SUCCESS:
      return {
        ...state,
        isFetchingMemberMpi: false,
      };

    case types.GET_MEMBER_MPI_FAILURE:
      return {
        ...state,
        isFetchingMemberMpi: false,
      };

    case types.UPDATE_HMO_METRICS_REQUEST:
      return {
        ...state,
        isUpdatingHmoMetrics: true,
      };

    case types.UPDATE_HMO_METRICS_SUCCESS:
      return {
        ...state,
        isUpdatingHmoMetrics: false,
      };

    case types.UPDATE_HMO_METRICS_FAILURE:
      return {
        ...state,
        isUpdatingHmoMetrics: false,
      };

    case types.REFRESH_MEMBER_AWV_STATUS_REQUEST:
      return {
        ...state,
        isRefreshingMemberAwvStatus: true,
      };

    case types.REFRESH_MEMBER_AWV_STATUS_SUCCESS:
      return {
        ...state,
        isRefreshingMemberAwvStatus: false,
      };

    case types.REFRESH_MEMBER_AWV_STATUS_FAILURE:
      return {
        ...state,
        isRefreshingMemberAwvStatus: false,
      };

    case types.DOWNLOAD_MEMBER_PAFS_REQUEST:
      return {
        ...state,
        isDownloadingMemberPafs: true,
      };

    case types.DOWNLOAD_MEMBER_PAFS_SUCCESS:
      return {
        ...state,
        isDownloadingMemberPafs: false,
      };

    case types.DOWNLOAD_MEMBER_PAFS_FAILURE:
      return {
        ...state,
        isDownloadingMemberPafs: false,
      };

    case types.MEMBER_STATUS_EXCEL_REQUEST:
      return {
        ...state,
        isDownloadingMemberStatusExcel: true,
      };

    case types.MEMBER_STATUS_EXCEL_SUCCESS:
      return {
        ...state,
        isDownloadingMemberStatusExcel: false,
      };

    case types.MEMBER_STATUS_EXCEL_FAILURE:
      return {
        ...state,
        isDownloadingMemberStatusExcel: false,
      };

    case types.MEMBER_STATUS_PDF_REQUEST:
      return {
        ...state,
        isDownloadingMemberStatusPdf: true,
      };

    case types.MEMBER_STATUS_PDF_SUCCESS:
      return {
        ...state,
        isDownloadingMemberStatusPdf: false,
      };

    case types.MEMBER_STATUS_PDF_FAILURE:
      return {
        ...state,
        isDownloadingMemberStatusPdf: false,
      };

    default:
      return state;
  }
};

export default hmoReducer;
